import type { IFAQMeta } from '@sravni/types/lib/seo';

import { escapeHTMLTags } from '@src/helpers/seo';
import type { ICreateSchemaParams, SchemaJsonLD } from 'entities/Seo/types';

export const mapFAQtoSchema = ({ seo }: ICreateSchemaParams): SchemaJsonLD.FAQPage => {
  const faq = seo?.contentBlocks?.find((value): value is IFAQMeta => value.type === 'faq')?.serviceResponseData?.items;

  if (!faq) {
    return undefined;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faq.map(({ question, answer }) => ({
      '@type': 'Question',
      name: escapeHTMLTags(question),
      acceptedAnswer: {
        '@type': 'Answer',
        text: escapeHTMLTags(answer),
      },
    })),
  };
};
